import { FC } from 'react';
import { PieChart, Pie, Cell, ResponsiveContainer } from 'recharts';
import { primaryColor } from '@/../tailwind.config';

interface CompletionChartProps {
  completedCount: number;
  totalCount: number;
  size?: 'small' | 'large';
}

const COLORS = [primaryColor, '#E5E7EB'];

const CompletionChart: FC<CompletionChartProps> = ({ completedCount, totalCount, size = 'large' }) => {
  const completionPercentage = totalCount > 0 ? Math.round((completedCount / totalCount) * 100) : 0;

  // When totalCount is 0, show full empty arc (remaining = 1) so the chart is visible
  const data = totalCount > 0
    ? [
        { name: 'completed', value: completedCount },
        { name: 'remaining', value: totalCount - completedCount },
      ]
    : [
        { name: 'completed', value: 0 },
        { name: 'remaining', value: 1 },
      ];

  const chartConfig = {
    small: {
      height: 85,
      innerRadius: 40,
      outerRadius: 60,
      fontSize: 'text-xl',
      padding: 'p-2',
      marginBottom: 'mb-1',
      marginTop: 'mt-2',
    },
    large: {
      height: 100,
      innerRadius: 50,
      outerRadius: 70,
      fontSize: 'text-2xl',
      padding: 'p-3',
      marginBottom: 'mb-2',
      marginTop: 'mt-2',
    },
  };

  const config = chartConfig[size];

  return (
    <div
      className={`bg-white rounded-[20px] border border-[#CCCCCC] border-opacity-50 ${config.padding} flex flex-col items-center justify-center ${size === 'large' ? 'min-w-[280px]' : 'w-full max-w-[400px]'}`}
    >
      <h3 className={`text-sm font-medium ${config.marginBottom}`}>% Papers completed</h3>
      <div className="w-full" style={{ height: config.height }}>
        <ResponsiveContainer width="100%" height="100%">
          <PieChart>
            <Pie
              data={data}
              cx="50%"
              cy="100%"
              innerRadius={config.innerRadius}
              outerRadius={config.outerRadius}
              startAngle={180}
              endAngle={0}
              dataKey="value"
            >
              {data.map((_, index) => (
                <Cell key={`cell-${index}`} fill={COLORS[index]} />
              ))}
            </Pie>
          </PieChart>
        </ResponsiveContainer>
      </div>
      <p className={`${config.fontSize} font-bold text-primary ${config.marginTop}`}>{completionPercentage}%</p>
    </div>
  );
};

export default CompletionChart;
